import Link from 'next/link';

export default function DimensionsSection() {
  const dimensions = [
    { num: '01', title: 'Alinhamento Estratégico' },
    { num: '02', title: 'Reorganização e Processos' },
    { num: '03', title: 'Liderança e Gestão de Pessoas' },
    { num: '04', title: 'Execução e Monitorização' },
  ];

  const deliverables = [
    'Índice de maturidade organizacional',
    'Avaliação por dimensão',
    'Identificação das áreas críticas',
    'Recomendações prioritárias de intervenção',
    'Possibilidade de agendar uma reunião de análise com a GestPub',
  ];

  return (
    <>
      {/* Diagnóstico Gratuito Section */}
      <section id="diagnostico" className="py-20 lg:py-24" style={{ backgroundColor: '#F8F9FA' }}>
        <div className="max-w-6xl mx-auto px-6">
          <div className="grid lg:grid-cols-2 gap-14 items-start">
            <div>
              <div className="flex items-center gap-3 mb-4">
                <div className="h-px w-8" style={{ backgroundColor: '#D1D5DB' }} />
                <span style={{ fontFamily: 'DM Sans, sans-serif', fontSize: '0.7rem', fontWeight: 600, letterSpacing: '0.12em', textTransform: 'uppercase', color: '#9CA3AF' }}>
                  Diagnóstico gratuito
                </span>
              </div>
              <h2
                style={{ fontFamily: 'DM Sans, sans-serif', fontWeight: 700, fontSize: 'clamp(1.5rem, 3vw, 1.875rem)', lineHeight: 1.25, color: '#1a1a1a', marginBottom: '1.25rem', letterSpacing: '-0.02em' }}
              >
                Comece com um diagnóstico gratuito
              </h2>
              <p style={{ fontFamily: 'DM Sans, sans-serif', fontSize: '0.95rem', color: '#6B7280', lineHeight: 1.75, marginBottom: '0.875rem' }}>
                Antes de qualquer intervenção, o Município pode realizar um diagnóstico preliminar gratuito de capacidade organizacional.
              </p>
              <p style={{ fontFamily: 'DM Sans, sans-serif', fontSize: '0.95rem', color: '#6B7280', lineHeight: 1.75, marginBottom: '1.5rem' }}>
                Em poucos minutos, o questionário permite identificar o nível de maturidade organizacional do Município em quatro dimensões essenciais:
              </p>

              {/* Dimensions list */}
              <div className="space-y-2.5 mb-8">
                {dimensions.map((d) => (
                  <div
                    key={d.num}
                    className="flex items-center gap-4 p-4 bg-white"
                    style={{ borderRadius: '5px', border: '1px solid #E5E7EB' }}
                  >
                    <span style={{ fontFamily: 'DM Sans, sans-serif', fontSize: '0.75rem', fontWeight: 700, color: '#009688', minWidth: '1.75rem' }}>
                      {d.num}
                    </span>
                    <span style={{ fontFamily: 'DM Sans, sans-serif', fontSize: '0.9rem', fontWeight: 600, color: '#1a1a1a' }}>
                      {d.title}
                    </span>
                  </div>
                ))}
              </div>

              <Link
                href="/multi-step-questionnaire"
                className="inline-flex items-center justify-center gap-2.5 px-8 py-3.5 text-white font-semibold text-sm transition-all duration-200"
                style={{ fontFamily: 'DM Sans, sans-serif', borderRadius: '4px', backgroundColor: '#009688', letterSpacing: '0.01em' }}
                onMouseEnter={(e) => { (e.currentTarget as HTMLAnchorElement).style.backgroundColor = '#00796B'; }}
                onMouseLeave={(e) => { (e.currentTarget as HTMLAnchorElement).style.backgroundColor = '#009688'; }}
              >
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
                  <path d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2" />
                  <rect x="9" y="3" width="6" height="4" rx="1" />
                  <line x1="9" y1="12" x2="15" y2="12" />
                  <line x1="9" y1="16" x2="12" y2="16" />
                </svg>
                Iniciar diagnóstico gratuito
              </Link>

              <p
                className="mt-5"
                style={{ fontFamily: 'DM Sans, sans-serif', fontSize: '0.8rem', color: '#9CA3AF', lineHeight: 1.65, maxWidth: '50ch' }}
              >
                As respostas são confidenciais e utilizadas exclusivamente para gerar o relatório de diagnóstico e, caso solicitado, apoiar uma análise posterior pela equipa da GestPub.
              </p>
            </div>

            {/* What you receive */}
            <div>
              <div className="flex items-center gap-3 mb-4">
                <div className="h-px w-8" style={{ backgroundColor: '#D1D5DB' }} />
                <span style={{ fontFamily: 'DM Sans, sans-serif', fontSize: '0.7rem', fontWeight: 600, letterSpacing: '0.12em', textTransform: 'uppercase', color: '#9CA3AF' }}>
                  O que recebe no final
                </span>
              </div>
              <h2
                style={{ fontFamily: 'DM Sans, sans-serif', fontWeight: 700, fontSize: 'clamp(1.5rem, 3vw, 1.875rem)', lineHeight: 1.25, color: '#1a1a1a', marginBottom: '1.25rem', letterSpacing: '-0.02em' }}
              >
                O que recebe no final?
              </h2>
              <p style={{ fontFamily: 'DM Sans, sans-serif', fontSize: '0.95rem', color: '#6B7280', lineHeight: 1.75, marginBottom: '1.5rem' }}>
                Após o preenchimento, o Município recebe automaticamente uma leitura preliminar da sua capacidade organizacional, com informação útil para apoiar a reflexão interna e identificar prioridades de melhoria.
              </p>

              <div className="space-y-2.5">
                {deliverables.map((item, i) => (
                  <div
                    key={i}
                    className="flex items-start gap-3.5 p-4 bg-white"
                    style={{ borderRadius: '5px', border: '1px solid #E5E7EB' }}
                  >
                    <div
                      className="flex-shrink-0 flex items-center justify-center w-5 h-5 mt-0.5"
                      style={{ borderRadius: '50%', backgroundColor: 'rgba(0,150,136,0.1)' }}
                    >
                      <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="#009688" strokeWidth="3" aria-hidden="true">
                        <polyline points="20 6 9 17 4 12" />
                      </svg>
                    </div>
                    <span style={{ fontFamily: 'DM Sans, sans-serif', fontSize: '0.875rem', color: '#374151', lineHeight: 1.65 }}>
                      {item}
                    </span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Da análise à intervenção */}
      <section id="intervencao" className="py-20 lg:py-24" style={{ backgroundColor: '#FFFFFF' }}>
        <div className="max-w-6xl mx-auto px-6">
          <div className="mb-14">
            <div className="flex items-center gap-3 mb-4">
              <div className="h-px w-8" style={{ backgroundColor: '#D1D5DB' }} />
              <span style={{ fontFamily: 'DM Sans, sans-serif', fontSize: '0.7rem', fontWeight: 600, letterSpacing: '0.12em', textTransform: 'uppercase', color: '#9CA3AF' }}>
                Do diagnóstico à intervenção
              </span>
            </div>
            <h2
              style={{ fontFamily: 'DM Sans, sans-serif', fontWeight: 700, fontSize: 'clamp(1.5rem, 3vw, 1.875rem)', lineHeight: 1.25, color: '#1a1a1a', marginBottom: '0.875rem', letterSpacing: '-0.02em' }}
            >
              Do diagnóstico à intervenção concreta
            </h2>
            <p style={{ maxWidth: '56ch', fontFamily: 'DM Sans, sans-serif', fontSize: '0.95rem', color: '#6B7280', lineHeight: 1.75 }}>
              O diagnóstico é apenas o ponto de partida. Com base nos resultados, a GestPub pode apoiar o Município na construção de um plano de intervenção concreto.
            </p>
          </div>

          {/* 4 steps */}
          <div className="grid md:grid-cols-4 gap-y-10 gap-x-0">
            {[
              {
                num: '01',
                title: 'Diagnóstico organizacional',
                description: 'Levantamento preliminar da realidade interna e identificação das principais fragilidades.',
              },
              {
                num: '02',
                title: 'Análise funcional e processual',
                description: 'Avaliação de funções, responsabilidades, fluxos de trabalho, circuitos de decisão e articulação entre serviços.',
              },
              {
                num: '03',
                title: 'Plano de intervenção',
                description: 'Definição de recomendações práticas, prioridades de atuação, cronograma e medidas de melhoria.',
              },
              {
                num: '04',
                title: 'Acompanhamento e capacitação',
                description: 'Apoio à implementação das medidas, monitorização de resultados e reforço da capacidade interna.',
              },
            ].map((step, idx, arr) => (
              <div key={step.num} className="relative flex flex-col">
                <div className="flex items-center mb-6">
                  <div
                    className="flex items-center justify-center w-9 h-9 flex-shrink-0"
                    style={{ borderRadius: '5px', backgroundColor: '#F8F9FA', border: '1px solid #D1D5DB' }}
                  >
                    <span style={{ fontFamily: 'DM Sans, sans-serif', fontSize: '0.75rem', fontWeight: 700, color: '#272727' }}>
                      {step.num}
                    </span>
                  </div>
                  {idx < arr.length - 1 && (
                    <div className="flex-1 h-px mx-3 hidden md:block" style={{ backgroundColor: '#E5E7EB' }} />
                  )}
                </div>
                <div className="pr-6">
                  <h4
                    style={{ fontFamily: 'DM Sans, sans-serif', fontSize: '0.975rem', fontWeight: 700, color: '#1a1a1a', marginBottom: '0.5rem', letterSpacing: '-0.01em' }}
                  >
                    {step.title}
                  </h4>
                  <p style={{ fontFamily: 'DM Sans, sans-serif', fontSize: '0.875rem', color: '#6B7280', lineHeight: 1.7 }}>
                    {step.description}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}